<template>
    <div class="col-lg-4 col-md-6 portfolio-item filter-app">

        <div class="portfolio-wrap">
            <figure>
                <img :src="item.image" class="img-fluid-service" alt="">
<!--                <a :href="item.image" data-lightbox="portfolio"-->
<!--                   data-title="App 1"-->
<!--                   class="link-preview">-->
<!--                    <i class="ion ion-eye"></i>-->
<!--                </a>-->
<!--                <a href="portfolio-details.html" class="link-details" title="More Details">-->
<!--                    <i class="ion ion-android-open"></i>-->
<!--                </a>-->
            </figure>

            <div class="portfolio-info">
                <h4>
                    <a href="javascript:void(0)">
                        <span style="font-size: 12px;color: #000000">{{ item.title }}</span>
                    </a>
                </h4>
<!--                <p>App</p>-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Reference",
        props:{
            item: {
                type: Object
            }
        }
    }
</script>

<style lang="scss" scoped>
    .img-fluid-service {
        width: 100%;
        height: 100%;
        /*margin: 0px 73px;*/
    }
</style>